import SvelteHeatmap from './SvelteHeatmap.svelte';

SvelteHeatmap.VERSION = '1.0.2';

export default SvelteHeatmap;
